export default __webpack_public_path__ + "static/media/acenergyLogo.26368143.png";